import React from 'react';

import start from '@portals/framework';
import {
  PartnerFeatureFlagsType,
  PartnerPortalCapabilities,
  PartnerPricingPlanFeatures,
  TenantType,
} from '@portals/types';

import { PartnerDataLayout } from './app/components/PartnerDataLayout';
import PartnersMeta from './app/components/PartnersMeta';
import {
  AuthLayoutWrapper,
  DashboardLayoutWrapper,
} from './app/components/ResponsiveWrapper';
import modals from './app/modals';
import { routes } from './app/routes';

start<
  PartnerFeatureFlagsType,
  PartnerPortalCapabilities,
  PartnerPricingPlanFeatures
>(routes, modals, TenantType.Partner, {
  globalLayout: () => <PartnersMeta />,
  dashboardDataLayout: PartnerDataLayout,
  dashboardLayout: DashboardLayoutWrapper,
  authLayout: AuthLayoutWrapper,
});
